module.exports = __webpack_public_path__ + "static/media/default-picture.2e60afa3.png";